<p>
  test works!
</p>
<!-- <div id="div_oil">
</div>
<div id="chartContainer" style="width: 50%; margin-left:auto;margin-right:auto;"></div> -->

<!-- <highcharts-chart [Highcharts]="highcharts" [options]="chartOptions"
  style="width: 800px; height: 400px; display: block; background-color: aqua;">
</highcharts-chart> -->
<!-- 
<div id="script_chart"></div> -->

<!-- <div id="container" style="width:100%; height:400px;"></div> -->

<!-- <div id="container"></div> -->

<div id="container" [chart]="chart"></div>